import React from "react";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./ParticipantList.scss";

const SKELETON_ROW_COUNT = 5;

/**
 * Renders skeleton loading rows while participant data is loading.
 */
const ParticipantListSkeleton = () => {
  return (
    <div className={classes.skeletonContainer}>
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`${index}-skeleton`} className={classes.skeletonRow}>
          <SkeletonLoader width="36px" height="36px" borderRadius="4px" />
          <div className={classes.skeletonText}>
            <SkeletonLoader width="140px" height="14px" />
            <SkeletonLoader width="220px" height="12px" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ParticipantListSkeleton;
